import { EnumCompanyStatus } from "@/Domain/EnumCompanyStatus";
import { computed } from "vue";
import { LocAppGroup } from "./RoleGroups";
import { useMainStore } from "@/stores/useMainStore";

export const authorizedForLocDownloads = function () {
  const main = useMainStore();
  return computed(() => {
    return (
      main.isInAnyRole(LocAppGroup.roles) &&
      main.companySummary &&
      !main.companySummary.onLocHold &&
      main.companySummary.denials.every(
        (d) => !d.LOC || d.LOC.toUpperCase() !== "ALL"
      ) &&
      main.companySummary.status === EnumCompanyStatus.Certified
    );
  });
};
